import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import logo from "../../assets/logo.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [scrolled, setScrolled] = useState(false); // 🔥 NEW STATE

  const lastScrollY = useRef(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Background change after 50px
      if (currentScrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      if (Math.abs(currentScrollY - lastScrollY.current) < 10) return;

      if (currentScrollY <= 0) {
        setShowNavbar(true);
      } else if (currentScrollY < lastScrollY.current) {
        setShowNavbar(true);
      } else {
        setShowNavbar(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`${styles.navbar} 
          ${showNavbar ? styles.showNav : styles.hideNav} 
          ${scrolled ? styles.scrolled : ""}`}
      >
        {/* Left Menu */}
        <div className={styles.leftMenu}>
          <span
            className={`${styles.link} ${
              location.pathname === "/" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/")}
          >
            HOME
          </span>

          <span
            className={`${styles.link} ${
              location.pathname === "/about" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/about")}
          >
            ABOUT US
          </span>

          <span
            className={`${styles.link} ${
              location.pathname === "/events" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/events")}
          >
            EVENTS
          </span>
        </div>

        {/* Logo */}
        <div className={styles.logo} onClick={() => handleNavigate("/")}>
          <img src={logo} alt="Swagger" />
        </div>

        {/* Right Menu */}
        <div className={styles.rightMenu}>
          <span
            className={`${styles.link} ${
              location.pathname === "/menu" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/menu")}
          >
            MENU
          </span>

          <span
            className={`${styles.link} ${
              location.pathname === "/careers" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/careers")}
          >
            CAREERS
          </span>

          <span
            className={`${styles.link} ${
              location.pathname === "/contact" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/contact")}
          >
            CONTACT
          </span>
        </div>

        {/* Mobile Toggle */}
        <div
          className={styles.menuToggle}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          ☰
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`${styles.mobileMenu} ${
          menuOpen ? styles.showMobile : ""
        }`}
      >
        <div className={styles.mobileHeader}>
          <img src={logo} alt="Swagger" onClick={() => handleNavigate("/")} />
          <div
            className={styles.closeBtn}
            onClick={() => setMenuOpen(false)}
          >
            ✕
          </div>
        </div>

        <div className={styles.mobileLinks}>
          {[
            { path: "/", label: "HOME" },
            { path: "/about", label: "ABOUT" },
            { path: "/events", label: "EVENTS" },
            { path: "/menu", label: "MENU" },
            { path: "/careers", label: "CAREERS" },
            { path: "/contact", label: "CONTACT" },
          ].map((item) => (
            <span
              key={item.path}
              className={`${styles.mobileLink} ${
                location.pathname === item.path
                  ? styles.mobileActive
                  : ""
              }`}
              onClick={() => handleNavigate(item.path)}
            >
              {item.label}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default Navbar;
